import I18n from 'I18n';
import PortalIdParser from 'PortalIdParser';
import { getPropertyValue } from 'framework-asset-preview-lib/internal/shared/utils/crmObject';
import { STATUS } from 'framework-asset-preview-lib/internal/shared/constants/assetPreview';
import { OBJECT_TYPE } from 'framework-asset-preview-lib/internal/shared/constants/objectTypes';
import { fetchContentStatistics } from './api';
const ContentTypes = {
  BLOG: 3,
  LANDING_PAGE: 1,
  SITE_PAGE: 4
};
const BlogPostStates = {
  AUTOMATED_DRAFT: 'AUTOMATED_DRAFT',
  AUTOMATED_FOR_FORM_BUFFER: 'AUTOMATED_FOR_FORM_BUFFER',
  AUTOMATED_FOR_FORM_DRAFT: 'AUTOMATED_FOR_FORM_DRAFT',
  BLOG_EMAIL_DRAFT: 'BLOG_EMAIL_DRAFT',
  DISCARDABLE_STUB: 'DISCARDABLE_STUB',
  DRAFT: 'DRAFT',
  DRAFT_AB: 'DRAFT_AB',
  DRAFT_AB_VARIANT: 'DRAFT_AB_VARIANT',
  ERROR: 'ERROR',
  LOSER_AB_VARIANT: 'LOSER_AB_VARIANT',
  PAGE_STUB: 'PAGE_STUB',
  RSS_TO_EMAIL_DRAFT: 'RSS_TO_EMAIL_DRAFT',
  AUTOMATED: 'AUTOMATED',
  AUTOMATED_FOR_FORM: 'AUTOMATED_FOR_FORM',
  AUTOMATED_FOR_FORM_LEGACY: 'AUTOMATED_FOR_FORM_LEGACY',
  AUTOMATED_SENDING: 'AUTOMATED_SENDING',
  BLOG_EMAIL_PUBLISHED: 'BLOG_EMAIL_PUBLISHED',
  PRE_PROCESSING: 'PRE_PROCESSING',
  PROCESSING: 'PROCESSING',
  PUBLISHED: 'PUBLISHED',
  PUBLISHED_AB: 'PUBLISHED_AB',
  PUBLISHED_AB_VARIANT: 'PUBLISHED_AB_VARIANT',
  PUBLISHED_NO_CONTACTS: 'PUBLISHED_NO_CONTACTS',
  PUBLISHED_OR_SCHEDULED: 'PUBLISHED_OR_SCHEDULED',
  RSS_TO_EMAIL_PUBLISHED: 'RSS_TO_EMAIL_PUBLISHED',
  SCHEDULED: 'SCHEDULED',
  SCHEDULED_AB: 'SCHEDULED_AB'
};
const BLOG_POST_PUBLISHED_STATES = [BlogPostStates.AUTOMATED, BlogPostStates.AUTOMATED_FOR_FORM, BlogPostStates.AUTOMATED_FOR_FORM_LEGACY, BlogPostStates.AUTOMATED_SENDING, BlogPostStates.BLOG_EMAIL_PUBLISHED, BlogPostStates.PRE_PROCESSING, BlogPostStates.PROCESSING, BlogPostStates.PUBLISHED, BlogPostStates.PUBLISHED_AB, BlogPostStates.PUBLISHED_AB_VARIANT, BlogPostStates.PUBLISHED_NO_CONTACTS, BlogPostStates.PUBLISHED_OR_SCHEDULED, BlogPostStates.RSS_TO_EMAIL_PUBLISHED];
const BLOG_POST_DRAFT_STATES = [BlogPostStates.AUTOMATED_DRAFT, BlogPostStates.AUTOMATED_FOR_FORM_BUFFER, BlogPostStates.AUTOMATED_FOR_FORM_DRAFT, BlogPostStates.BLOG_EMAIL_DRAFT, BlogPostStates.DISCARDABLE_STUB, BlogPostStates.DRAFT, BlogPostStates.DRAFT_AB, BlogPostStates.DRAFT_AB_VARIANT, BlogPostStates.ERROR, BlogPostStates.LOSER_AB_VARIANT, BlogPostStates.PAGE_STUB, BlogPostStates.RSS_TO_EMAIL_DRAFT];
const BLOG_POST_SCHEDULED_STATES = [BlogPostStates.SCHEDULED, BlogPostStates.SCHEDULED_AB, BlogPostStates.PUBLISHED_OR_SCHEDULED];
const PageStates = {
  PUBLISHED: 'PUBLISHED',
  PUBLISHED_OR_SCHEDULED: 'PUBLISHED_OR_SCHEDULED',
  DRAFT: 'DRAFT',
  SCHEDULED: 'SCHEDULED',
  PUBLISHED_AB: 'PUBLISHED_AB',
  PUBLISHED_AB_VARIANT: 'PUBLISHED_AB_VARIANT',
  LOSER_AB_VARIANT: 'LOSER_AB_VARIANT',
  DRAFT_AB: 'DRAFT_AB',
  DRAFT_AB_VARIANT: 'DRAFT_AB_VARIANT',
  SCHEDULED_AB: 'SCHEDULED_AB'
};
const PAGE_PUBLISHED_STATES = [PageStates.PUBLISHED, PageStates.PUBLISHED_OR_SCHEDULED, PageStates.PUBLISHED_AB, PageStates.PUBLISHED_AB_VARIANT];
const PAGE_DRAFT_STATES = [PageStates.DRAFT, PageStates.DRAFT_AB, PageStates.DRAFT_AB_VARIANT, PageStates.LOSER_AB_VARIANT];
const PAGE_SCHEDULED_STATES = [PageStates.SCHEDULED, PageStates.SCHEDULED_AB, PageStates.PUBLISHED_OR_SCHEDULED];
const CONTENT_COMMON_PROPERTY_MAP = {
  ab: 'hs_ab',
  archived: 'hs_archived',
  abTestId: 'hs_ab_test_id',
  audienceAccessType: 'hs_audience_access_type',
  authorName: 'hs_blog_author_id',
  businessUnitId: 'hs_all_assigned_business_unit_ids',
  campaign: 'hs_campaign',
  contentTypeCategoryId: 'hs_content_type_category_id',
  created: 'hs_createdate',
  createdById: 'hs_created_by_user_id',
  currentState: 'hs_current_state',
  htmlTitle: 'hs_html_title',
  id: 'hs_origin_asset_id',
  language: 'hs_language',
  mab: 'hs_mab',
  mabExperimentId: 'hs_mab_experiment_id',
  name: 'hs_name',
  password: 'hs_password',
  previewKey: 'hs_preview_key',
  publicAccessRules: 'hs_public_access_rules',
  publicAccessRulesEnabled: 'hs_public_access_rules_enabled',
  publishDate: 'hs_publish_date',
  resolvedDomain: 'hs_resolved_domain',
  scheduledUpdateDate: 'hs_scheduled_update_date',
  screenshotPreviewUrl: 'hs_screenshot_preview_url',
  securityState: 'hs_security_state',
  state: 'hs_state',
  updatedById: 'hs_updated_by_id',
  url: 'hs_url'
};
const BLOG_POST_PROPERTY_MAP = Object.assign({}, CONTENT_COMMON_PROPERTY_MAP, {
  postTemplate: 'hs_post_template'
});
const LANDING_PAGE_PROPERTY_MAP = Object.assign({}, CONTENT_COMMON_PROPERTY_MAP, {
  templatePath: 'hs_template_path'
});
const SITE_PAGE_PROPERTY_MAP = Object.assign({}, CONTENT_COMMON_PROPERTY_MAP, {
  templatePath: 'hs_template_path'
});
const CONTENT_PROPERTY_MAP = Object.assign({}, CONTENT_COMMON_PROPERTY_MAP, {
  postTemplate: 'hs_post_template',
  templatePath: 'hs_template_path'
});
const PROPERTY_MAP = {
  [OBJECT_TYPE.LANDING_PAGE]: LANDING_PAGE_PROPERTY_MAP,
  [OBJECT_TYPE.SITE_PAGE]: SITE_PAGE_PROPERTY_MAP,
  [OBJECT_TYPE.BLOG_POST]: BLOG_POST_PROPERTY_MAP,
  [OBJECT_TYPE.CONTENT]: CONTENT_PROPERTY_MAP
};
export function getNonCrmPropertyValue(propertyName, nonCrmObject) {
  if (!nonCrmObject) {
    return undefined;
  }
  const contentResponse = nonCrmObject;
  if (propertyName in contentResponse) {
    return contentResponse[propertyName];
  }
  return undefined;
}
export function contentObjectToCrmObject(crmObject, contentObject) {
  if (!contentObject) {
    return crmObject;
  }
  return Object.entries(contentObject).reduce((acc, entry) => {
    const [propertyName, propertyValue] = entry;
    const hsPropertyName = PROPERTY_MAP[crmObject.objectTypeId][propertyName];
    if (!hsPropertyName) {
      return acc;
    }
    acc.properties[hsPropertyName] = {
      value: propertyValue
    };
    return acc;
  }, Object.assign({}, crmObject, {
    associatedObjects: Object.assign({}, crmObject.associatedObjects || {}),
    portalId: PortalIdParser.get()
  }));
}
export function getMembershipSsoEnabledForDomain(resolvedDomain, portalSettings) {
  if (!portalSettings || !portalSettings.bodyOverrideByDomain || !portalSettings.bodyOverrideByDomain[resolvedDomain]) {
    return false;
  }
  const {
    membershipJwtEnabled,
    membershipSsoEnabled
  } = portalSettings.bodyOverrideByDomain[resolvedDomain];
  return membershipJwtEnabled || membershipSsoEnabled;
}
export function getContentType(crmObject) {
  if (crmObject.objectTypeId === OBJECT_TYPE.BLOG_POST) {
    return 'blog';
  } else if (crmObject.objectTypeId === OBJECT_TYPE.LANDING_PAGE) {
    return 'landing';
  } else if (crmObject.objectTypeId === OBJECT_TYPE.SITE_PAGE) {
    return 'site';
  }
  const contentType = getPropertyValue(crmObject, 'hs_content_type_category_id');
  const contentTypeNum = parseInt(contentType, 10);
  switch (contentTypeNum) {
    case ContentTypes.BLOG:
      return 'blog';
    case ContentTypes.LANDING_PAGE:
      return 'landing';
    case ContentTypes.SITE_PAGE:
      return 'site';
    default:
      return '';
  }
}
export function getContentTypeCategoryId(crmObject) {
  if (crmObject.objectTypeId === OBJECT_TYPE.BLOG_POST) {
    return ContentTypes.BLOG;
  } else if (crmObject.objectTypeId === OBJECT_TYPE.LANDING_PAGE) {
    return ContentTypes.LANDING_PAGE;
  } else if (crmObject.objectTypeId === OBJECT_TYPE.SITE_PAGE) {
    return ContentTypes.SITE_PAGE;
  }
  const contentType = getPropertyValue(crmObject, 'hs_content_type_category_id');
  return parseInt(contentType, 10);
}
export function getIsBlogPost(crmObject) {
  const contentType = getContentType(crmObject);
  return contentType === 'blog';
}
export function getIsInViolation(nonCrmObject) {
  const hsSecurityState = getNonCrmPropertyValue('securityState', nonCrmObject);
  return [`${STATUS.FLAGGED_FOR_REVIEW}`, `${STATUS.SECURITY_VIOLATION}`].includes(`${hsSecurityState}`);
}
export function getPublishStatus(isBlogPost, nonCrmObject) {
  if (isBlogPost) {
    return getNonCrmPropertyValue('state', nonCrmObject);
  }
  return getNonCrmPropertyValue('currentState', nonCrmObject);
}
export function getIsDraft(crmObject, nonCrmObject) {
  const isBlogPost = getIsBlogPost(crmObject);
  const publishStatus = getPublishStatus(isBlogPost, nonCrmObject);
  const draftStates = isBlogPost ? BLOG_POST_DRAFT_STATES : PAGE_DRAFT_STATES;
  return draftStates.includes(`${publishStatus}`);
}
export function getIsPublished(crmObject, nonCrmObject) {
  const isBlogPost = getIsBlogPost(crmObject);
  const publishStatus = getPublishStatus(isBlogPost, nonCrmObject);
  const publishedStates = isBlogPost ? BLOG_POST_PUBLISHED_STATES : PAGE_PUBLISHED_STATES;
  return publishedStates.includes(`${publishStatus}`);
}
export function getIsArchived(nonCrmObject) {
  const hsArchived = getNonCrmPropertyValue('archived', nonCrmObject);
  return Boolean(hsArchived);
}
export function getIsScheduled(crmObject, nonCrmObject) {
  const isBlogPost = getIsBlogPost(crmObject);
  const publishStatus = getPublishStatus(isBlogPost, nonCrmObject);
  const scheduledStates = isBlogPost ? BLOG_POST_SCHEDULED_STATES : PAGE_SCHEDULED_STATES;
  return scheduledStates.includes(`${publishStatus}`);
}
export function getIsPublishedWithScheduledUpdate(crmObject, nonCrmObject) {
  const hsScheduledUpdateDate = getNonCrmPropertyValue('scheduledUpdateDate', nonCrmObject);
  return getIsPublished(crmObject, nonCrmObject) && Boolean(hsScheduledUpdateDate);
}
export function getIsPublic(nonCrmObject) {
  const hsPublicAccessEnabled = getNonCrmPropertyValue('publicAccessRulesEnabled', nonCrmObject);
  const hsPassword = getNonCrmPropertyValue('password', nonCrmObject);
  return Boolean(hsPublicAccessEnabled) === false && !hsPassword;
}
export function getIsPasswordProtected(nonCrmObject) {
  const hsPassword = getNonCrmPropertyValue('password', nonCrmObject);
  return Boolean(hsPassword && `${hsPassword}`.length > 0);
}
export function getPublicAccessType(nonCrmObject) {
  const hsPublicAccessRules = getNonCrmPropertyValue('publicAccessRules', nonCrmObject);
  if (Array.isArray(hsPublicAccessRules) && hsPublicAccessRules.length > 0) {
    return hsPublicAccessRules[0].type;
  }
  return null;
}
export function getShareablePreviewURL(crmObject, nonCrmObject) {
  const id = getPropertyValue(crmObject, 'hs_content_id');
  const previewKey = getNonCrmPropertyValue('previewKey', nonCrmObject);
  const absoluteUrl = getNonCrmPropertyValue('url', nonCrmObject);
  if (!previewKey || getIsPublished(crmObject, nonCrmObject)) {
    return absoluteUrl;
  }
  const urlWithoutProtocol = absoluteUrl.replace(/^(http:\/\/)|(https:\/\/)/, '');
  return `https://${urlWithoutProtocol}?hs_preview=${previewKey}-${id}`;
}
export const getContentPrivateRegistrationListIds = nonCrmObject => {
  const publicAccessRules = getNonCrmPropertyValue('publicAccessRules', nonCrmObject);
  if (!publicAccessRules) {
    return [];
  } else if (typeof publicAccessRules === 'string') {
    try {
      const publicAccessRulesArray = JSON.parse(publicAccessRules);
      return publicAccessRulesArray.length > 0 ? publicAccessRulesArray[0].ids : [];
    } catch (e) {
      //noop
      return [];
    }
  } else if (publicAccessRules.length > 0) {
    return publicAccessRules[0].ids;
  }
  return [];
};
export function getContentStatus(crmObject, nonCrmObject) {
  const hsSecurityState = getNonCrmPropertyValue('securityState', nonCrmObject);
  const isInViolation = getIsInViolation(nonCrmObject);
  const isDraft = getIsDraft(crmObject, nonCrmObject);
  const isScheduled = getIsScheduled(crmObject, nonCrmObject);
  const isPublished = getIsPublished(crmObject, nonCrmObject);
  if (isInViolation) {
    return hsSecurityState === STATUS.FLAGGED_FOR_REVIEW ? STATUS.FLAGGED_FOR_REVIEW : STATUS.SECURITY_VIOLATION;
  } else if (isDraft) {
    return STATUS.DRAFT;
  } else if (isScheduled) {
    return STATUS.SCHEDULED;
  } else if (isPublished) {
    return STATUS.PUBLISHED;
  } else {
    return STATUS.DEFAULT;
  }
}
export function getContentPerformanceStats(crmObject) {
  return fetchContentStatistics(crmObject).then(contentStatistics => {
    const contentStatisticsWithTotals = contentStatistics.totals || {
      contacts: 0,
      customers: 0,
      entrances: 0,
      exitsPerPageview: 0,
      pageBounceRate: 0,
      rawViews: 0,
      submissions: 0,
      timePerPageview: 0
    };
    const timePerPageViewInt = contentStatisticsWithTotals.timePerPageview ? contentStatisticsWithTotals.timePerPageview.toFixed(0) : 0;
    const overviewPerfGroup = {
      stats: [{
        formatStyle: 'decimal',
        propertyName: 'hs_content_page_views',
        value: contentStatisticsWithTotals.rawViews
      }, {
        formatStyle: 'decimal',
        propertyName: 'hs_content_total_form_submissions',
        value: contentStatisticsWithTotals.submissions || 0
      }, {
        formatStyle: 'decimal',
        propertyName: 'hs_content_new_contacts',
        value: contentStatisticsWithTotals.contacts || 0
      }, {
        formatStyle: 'decimal',
        propertyName: 'hs_content_new_customers',
        value: contentStatisticsWithTotals.customers || 0
      }, {
        formatStyle: 'percentage',
        propertyName: 'hs_content_bounce_rate',
        value: contentStatisticsWithTotals.pageBounceRate * 100
      }, {
        formatStyle: 'text',
        propertyName: 'hs_content_time_per_page_view',
        value: timePerPageViewInt === 0 ? '0' : I18n.text('frameworkAssetPreviewLib.propertyValue.0-10.hs_content_time_per_page_view', {
          count: timePerPageViewInt,
          time: timePerPageViewInt
        })
      }, {
        formatStyle: 'percentage',
        propertyName: 'hs_content_exists_per_page_view',
        value: contentStatisticsWithTotals.exitsPerPageview ? contentStatisticsWithTotals.exitsPerPageview * 100 : 0
      }, {
        formatStyle: 'decimal',
        propertyName: 'hs_content_entrances',
        value: contentStatisticsWithTotals.entrances
      }],
      title: I18n.text('frameworkAssetPreviewLib.tabs.performance.performanceGroup.0-10.overview')
    };
    return [overviewPerfGroup];
  });
}